<template>
  <div class="topbar">
    <div class="header-content">
      <!-- 左侧：Logo + 欢迎语 -->
      <div class="left-section">
        <img class="logo" :src="logo" alt="logo" />
        <div class="text-container">
          <div class="welcome-line">
            <span class="w">{{ $t("common.welcome") }},</span>
            <span class="u">{{ username }}</span>
            <span class="b">{{ balanceText }}</span>
          </div>
          <div class="blank-line"></div>
        </div>
      </div>

      <!-- 右侧：语言 + 退出 -->
      <div class="right-section">
        <div class="text-container align-right">
          <div class="lang-line">
            <span
                class="lang"
                :class="{ on: curLang === 'en' }"
                @click="setLang('en')"
            >{{ $t("common.lang_en") }}</span>
            <span class="sep">|</span>
            <span
                class="lang"
                :class="{ on: curLang === 'km' }"
                @click="setLang('km')"
            >{{ $t("common.lang_km") }}</span>
            <span class="sep">|</span>
            <span
                class="lang"
                :class="{ on: curLang === 'zh' }"
                @click="setLang('zh')"
            >{{ $t("common.lang_zh") }}</span>
          </div>
          <div class="blank-line"></div>
        </div>
        <div class="logout-wrap">
          <button class="logout-btn" @click="$emit('logout')">
            {{ $t("common.logout") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    username: { type: String, default: "" },
    balance: { type: Number, default: 0 },
    currency: { type: String, default: "KHR" }
  },
  computed: {
    curLang() {
      return this.$i18n.locale;
    },
    logo() {
      return require("@/assets/img/login-logo.png");
    },
    balanceText() {
      // 15,350.00 (KHR)
      const v = Number(this.balance || 0);
      const formatted = v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return `${formatted} (${this.currency || "KHR"})`;
    }
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.$emit("lang-change", lang);
    }
  }
};
</script>

<style scoped>
.topbar {
  background: #ffffff;
  border-bottom: 1px solid #e6eef7;
  display: flex;
}

.header-content {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

.left-section, .right-section {
  display: flex;
  align-items: flex-start;
}

.logo {
  width: 83px;
  height: 60px;
  object-fit: contain;
  padding: 5px;
  box-sizing: border-box;
}

.text-container {
  display: flex;
  flex-direction: column;
}
.align-right { align-items: flex-end; }

.welcome-line, .lang-line {
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  font-size: 15px;
  white-space: nowrap;
}

.blank-line {
  height: 25px;
  width: 100%;
}

.w { color: #3c5aa0; font-weight: 600; font-size: 13px; }
.u { color: #03a378; font-weight: 800; margin: 0 6px; font-size: 13px; }
.b { color: #0037ff; font-weight: bold; font-size: 13px; }

.lang-line {
  color: #083261;
  font-size: 13px;
  user-select: none;
}
.lang { cursor: pointer; font-weight: bold; }
.lang.on { text-decoration: underline; font-weight: bold; }
.sep { margin: 0 8px; opacity: 0.6; }

.logout-wrap {
  width: 120px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 15px;
}

.logout-btn {
  width: 105px;
  height: 60px;
  background: #5d98e9;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logout-btn:hover {
  background: #4a86d7;
}
</style>
